export default "__VITE_ASSET__h2l$_dod__"